module.exports = __webpack_public_path__ + "img/ASFT_visualisoinnit_muokatut-01.83ac52bb.png";